import { render, staticRenderFns } from "./customers-app.vue?vue&type=template&id=499ee186"
import script from "./customers-app.vue?vue&type=script&lang=js"
export * from "./customers-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports